module.exports = __webpack_public_path__ + "static/img/7.72be025.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/7.png
// module id = fDVy
// module chunks = 0